import { trigger, transition, query, style, animate, group } from '@angular/animations';

export const fadeAnimation =
    trigger('routeAnimations', [
        transition('* <=> PublicacionesTag', []),
        transition('* <=> PublicacionId', []),
        transition('BlogCategory <=> Blog', []),
        transition('* => Blog', []),
        transition('* => *', [
            query(':enter, :leave',
                style({ position: 'fixed', width: '100%', opacity: 0, transform: 'translateY(10px)' }),
                { optional: true }),

            group([
                query(':leave', [
                    animate('300ms ease-in-out', style({ opacity: 0, transform: 'translateY(10px)' }))
                ], { optional: true }),
                query(':enter', [
                    style({ opacity: 0, transform: 'translateY(10px)' }),
                    animate('400ms ease-in-out', style({ opacity: 1, transform: 'translateY(0)' }))
                ], { optional: true })
            ])
        ])
    ]);
